(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["phb-image-lightbox"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__phbLightbox) return;
    window.__phbLightbox = true;

    var MAX_WIDTH = 2400;

    // Shopify-CDN-URL auf die grosse, unbeschnittene Variante umbauen.
    // height und crop muessen weg, sonst bleibt der Zuschnitt der Thumbnail-
    // Darstellung erhalten (z. B. bei image_ratio landscape).
    function fullSizeSrc(img) {
      var raw = img.currentSrc || img.src || '';
      try {
        var url = new URL(raw, window.location.href);
        url.searchParams.delete('height');
        url.searchParams.delete('crop');
        url.searchParams.set('width', String(MAX_WIDTH));
        return url.href;
      } catch (e) {
        return raw;
      }
    }

    function init(dialog) {
      if (dialog.__phbReady) return;
      dialog.__phbReady = true;

      var scopeSel = dialog.getAttribute('data-scope') || '#MainContent';
      var imgSel = dialog.getAttribute('data-selector') || '.image-block__image';
      var hint = dialog.getAttribute('data-hint') || '';
      var scope = document.querySelector(scopeSel) || document.body;
      var target = dialog.querySelector('[data-phb-lightbox-img]');
      var closeBtn = dialog.querySelector('[data-phb-lightbox-close]');
      if (!target) return;

      function open(img) {
        target.src = fullSizeSrc(img);
        target.alt = img.getAttribute('alt') || '';
        // Seitenverhaeltnis des Quellbildes uebernehmen, damit die
        // Platzhaltermasse im Markup nicht das Layout verfaelschen
        var w = img.naturalWidth || parseInt(img.getAttribute('width'), 10);
        var h = img.naturalHeight || parseInt(img.getAttribute('height'), 10);
        if (w && h) {
          target.setAttribute('width', String(w));
          target.setAttribute('height', String(h));
        }
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      }

      function release() {
        target.removeAttribute('src');
      }

      function close() {
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
        // Direkt hier freigeben statt nur im close-Event: Letzteres feuert
        // nicht in jeder Umgebung zuverlaessig. removeAttribute ist idempotent,
        // ein zusaetzlich feuerndes Event schadet daher nicht.
        release();
      }

      // Bilder als Bedienelement auszeichnen, damit Tastatur und
      // Screenreader sie erreichen. Bilder in Links bleiben unangetastet.
      function markTriggers() {
        var imgs = scope.querySelectorAll(imgSel);
        for (var i = 0; i < imgs.length; i++) {
          var img = imgs[i];
          if (img.__phbTrigger) continue;
          if (img.closest('a')) continue;
          img.__phbTrigger = true;
          img.classList.add('phb-lightbox-trigger');
          img.setAttribute('role', 'button');
          img.setAttribute('tabindex', '0');
          if (hint) img.setAttribute('title', hint);
        }
      }

      markTriggers();

      // Nachgeladene Bilder ebenfalls erfassen, gedrosselt per rAF
      var pending = false;
      var mo = new MutationObserver(function () {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(function () {
          pending = false;
          markTriggers();
        });
      });
      mo.observe(scope, { childList: true, subtree: true });

      scope.addEventListener('click', function (event) {
        var img = event.target.closest(imgSel);
        if (!img || !img.__phbTrigger) return;
        event.preventDefault();
        open(img);
      });

      scope.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        var img = event.target.closest(imgSel);
        if (!img || !img.__phbTrigger) return;
        event.preventDefault();
        open(img);
      });

      if (closeBtn) closeBtn.addEventListener('click', close);

      // Klick auf den Hintergrund schliesst. Der Dialog fuellt den Viewport,
      // deshalb wird gegen die Bildflaeche geprueft statt gegen den Dialog.
      dialog.addEventListener('click', function (event) {
        if (event.target === target) return;
        if (closeBtn && closeBtn.contains(event.target)) return;
        close();
      });

      // Zusaetzlich fuer die Wege, die close() nicht durchlaufen, etwa das
      // native Schliessen per Escape-Taste.
      dialog.addEventListener('close', release);
      dialog.addEventListener('cancel', release);
    }

    function start() {
      var dialogs = document.querySelectorAll('[data-phb-lightbox]');
      for (var i = 0; i < dialogs.length; i++) init(dialogs[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
